"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Box = void 0;
var hydrationHelpers_1 = require("../hydrationHelpers");
var react_1 = __importDefault(require("react"));
var Box_1 = require("@CommonFrontend/ContentTokens/SharedWidgetComponents/Box/Box");
var RenderTokensHostContext_1 = require("@CommonFrontend/ContentTokens/RenderTokensHost/RenderTokensHostContext");
var tiny_invariant_1 = __importDefault(require("tiny-invariant"));
var HydrationFriendlyBox = function (_a) {
    var columns = _a.columns, attributes = _a.attributes;
    return (react_1.default.createElement(Box_1.BoxWidget, { attributes: attributes, columns: [react_1.default.createElement(hydrationHelpers_1.ContentArea, { key: "0" }, columns === null || columns === void 0 ? void 0 : columns[0]), react_1.default.createElement(hydrationHelpers_1.ContentArea, { key: "1" }, columns === null || columns === void 0 ? void 0 : columns[1])] }));
};
var Box = function (_a) {
    var token = _a.token, attributes = _a.attributes;
    var RenderTokensHost = (0, RenderTokensHostContext_1.useRenderTokensHostContext)().RenderTokensHost;
    var renderedColumns = token.columns.map(function (column, index) { return react_1.default.createElement(RenderTokensHost, { key: index, tokens: column }); });
    (0, tiny_invariant_1.default)(renderedColumns.length === 2, "Box must have exactly 2 columns");
    return react_1.default.createElement(Box_1.BoxWidget, { attributes: attributes, columns: [renderedColumns[0], renderedColumns[1]] });
};
exports.Box = Box;
exports.default = (0, hydrationHelpers_1.withHydrationHost)(HydrationFriendlyBox, { componentName: "BoxWithHydration", ignoreProps: ["columns"] });
